import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { propBool, propShape, propFunc, propStr, } from '../../../../helpers/custom-prop-types';
const SlideSearchFilterCheckbox = (props) => {
    const { category, disabled, onChange, slideTypes } = props;
    const { id } = category;
    const inputId = `tags[${id}]`;
    const checked = useMemo(() => slideTypes.split(',').includes(id.toString()), [slideTypes, id]);
    return (_jsx("input", { checked: checked, className: 'category_item_check', disabled: !checked && disabled, id: inputId, name: inputId, onChange: onChange, type: 'checkbox', value: id }));
};
SlideSearchFilterCheckbox.propTypes = {
    category: propShape().isRequired,
    disabled: propBool(),
    onChange: propFunc().isRequired,
    slideTypes: propStr().isRequired,
};
SlideSearchFilterCheckbox.defaultProps = {
    disabled: false,
};
export default SlideSearchFilterCheckbox;
